module.exports = __webpack_public_path__ + "static/media/after-Introduksjon-sprakforstael.55fa272c.mp3";